import * as React from 'react';

import AdminUpgradeSidebar from 'admin/components/AdminUpgradeSidebar';
import Drift from 'components/Drift';
import Heading from 'components/Heading';
import List from 'components/List';
import Text from 'components/Text';
import TextWithGlyph from 'components/TextWithGlyph';

const features = [
  'Organization-wide messaging',
  'Community engagement statistics',
  'Oversight & advanced controls',
];

export default function AdminUpgradeInfo() {
  return (
    <AdminUpgradeSidebar
      headerImage={require('assets/images/admin/AdminUpgrade/school.svg')}
      textAlign="left"
      className="AdminUpgradeInfo">
      <Heading level="2" levelStyle="4">
        What’s included with a Remind plan:
      </Heading>
      <List size="small">
        {features.map(item => (
          <TextWithGlyph glyph="check" glyphColor="eclipse" glyphSize="medium" key={item}>
            {item}
          </TextWithGlyph>
        ))}
        <Text alignWithIcon>and more</Text>
      </List>
      <Drift />
    </AdminUpgradeSidebar>
  );
}
